'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Row;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _partition = require('lodash/partition');

var _partition2 = _interopRequireDefault(_partition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Row
 */

var defaultRightControls = [];

function createControlGroups(children, rightControls, classNames, style) {
  var controls = (0, _partition2.default)(children, function (component) {
    return rightControls.indexOf(component.type) === -1;
  });

  return _react2.default.createElement(
    'div',
    { className: classNames, style: style },
    _react2.default.createElement(
      'div',
      { className: _style2.default.componentGroup },
      controls[0]
    ),
    _react2.default.createElement(
      'div',
      { className: _style2.default.componentGroupRight },
      controls[1]
    )
  );
}

function shouldChangeVisibility(fadeOut, focused) {
  if (typeof fadeOut === 'function') {
    return fadeOut() && !focused;
  }
  return !focused && fadeOut;
}

function Row(props) {
  var rightControls = props.rightControls,
      focused = props.focused,
      fadeOut = props.fadeOut,
      fullWidth = props.fullWidth,
      style = props.style,
      className = props.className;


  var classNames = _style2.default.componentRow;

  if (fullWidth) {
    classNames = classNames + ' ' + _style2.default.fullWidth;
  }

  if (shouldChangeVisibility(fadeOut, focused)) {
    classNames = classNames + ' ' + _style2.default.hiddenRow;
  }

  if (className) {
    classNames = classNames + ' ' + className;
  }

  if (rightControls && rightControls.length >= 1) {
    var children = _react2.default.Children.toArray(props.children);
    return createControlGroups(children, rightControls, classNames, style);
  }

  return _react2.default.createElement(
    'div',
    { className: classNames, style: style },
    props.children
  );
}

Row.propTypes = {
  children: _propTypes2.default.node.isRequired,
  fadeOut: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  focused: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  playerId: _propTypes2.default.string,
  rightControls: _propTypes2.default.arrayOf(_propTypes2.default.func),
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

Row.defaultProps = {
  fullWidth: false,
  rightControls: defaultRightControls,
  style: {}
};
module.exports = exports['default'];